import { useScrollReveal } from '@/hooks/useScrollReveal';
import { ReactNode, type ElementType } from 'react';

type AnimationVariant =
  | 'fade-up'
  | 'fade-down'
  | 'fade-left'
  | 'fade-right'
  | 'fade-in'
  | 'scale-in'
  | 'scale-up';

interface ScrollRevealProps {
  children: ReactNode;
  variant?: AnimationVariant;
  delay?: number;
  duration?: number;
  className?: string;
  threshold?: number;
  as?: ElementType;
}

const variantClasses: Record<AnimationVariant, string> = {
  'fade-up': 'translate-y-8',
  'fade-down': '-translate-y-8',
  'fade-left': 'translate-x-8',
  'fade-right': '-translate-x-8',
  'fade-in': '',
  'scale-in': 'scale-95',
  'scale-up': 'scale-90',
};

export default function ScrollReveal({
  children,
  variant = 'fade-up',
  delay = 0,
  duration = 700,
  className = '',
  threshold = 0.12,
  as: Tag = 'div',
}: ScrollRevealProps) {
  const { ref, isVisible } = useScrollReveal({ threshold });

  return (
    <Tag
      ref={ref}
      className={`transition-all ${className}`}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible
          ? 'translate(0, 0) scale(1)'
          : variantClasses[variant],
        transitionDuration: `${duration}ms`,
        transitionDelay: `${delay}ms`,
        transitionTimingFunction: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
      }}
    >
      {children}
    </Tag>
  );
}